module.exports = __webpack_public_path__ + "static/media/mars.d09c7328.jpg";